import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { LanguageProvider } from './contexts/LanguageContext'
import Home from './pages/Home'
import Waitlist from './pages/Waitlist'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function AppContent() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const path = location.pathname
    const langMatch = path.match(/^\/(eng|rus)(\/|$)/)
    
    if (!langMatch && path !== '/waitlist' && path !== '/terms' && path !== '/privacy' && !path.startsWith('/eng') && !path.startsWith('/rus')) {
      const savedLang = localStorage.getItem('language') || 'en'
      navigate(`/${savedLang === 'en' ? 'eng' : 'rus'}`, { replace: true })
    }
  }, [location.pathname, navigate])

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/eng" element={<Home />} />
        <Route path="/rus" element={<Home />} />
        <Route path="/eng/waitlist" element={<Waitlist />} />
        <Route path="/rus/waitlist" element={<Waitlist />} />
        <Route path="/waitlist" element={<Waitlist />} />
        <Route path="/eng/terms" element={<Terms />} />
        <Route path="/rus/terms" element={<Terms />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/eng/privacy" element={<Privacy />} />
        <Route path="/rus/privacy" element={<Privacy />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </>
  )
}

function App() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  )
}

export default App
